(function() {
    'use strict';

    var app = angular.module('app');

    function isEmpty(value) {
        return angular.isUndefined(value) ||
            value === '' ||
            value === null ||
            value !== value;
    }

    app.directive('imgProduct', ['config',
        function(config) {
            //Usage:
            //<img data-img-product="{{i.file_name}}"/>
            var basePath = config.imageSettings.imageProductBasePath;
            var unknownImage = config.imageSettings.imageProductUnknown;
            var directive = {
                link: link,
                restrict: 'A'
            };
            return directive;

            function link(scope, element, attrs) {
                priority: 99,
                    attrs.$observe('imgProduct', function(value) {
                    value = basePath + (value || unknownImage);
                    attrs.$set('    src', value);
                });
            }
        }
    ]);

    app.directive('alertLink', ['config',
        function(config) {
            //Usage:
            //<a data-alert-link="{{item.link_id}}" data-alert-type="{{item.alert_type_id}}" target="_blank">{{item.link_id}}</a>
            var directive = {
                link: link,
                restrict: 'A'
            };
            var cases = {
                1: '/#/orders/',
                2: '/#/product/',
                3: '/#/stores/product/',
                4: '/#/vendor/product/',
                5: '/#/pickpack/details/',
                6: '/'
            };

            return directive;
            function link(scope, element, attrs) {

                priority: 99,
                    attrs.$observe('alertLink', function(value) {
                        value = cases[attrs.alertType] + value;
                        attrs.$set('href', value);
                    });
            }
        }
    ]);

    app.directive('storeLink', ['config',
        function(config) {
        var directive = {
            link: link,
            restrict: 'A'
        };

        return directive;
        function link(scope, element, attrs) {
            priority: 99,
                attrs.$observe('imgProd', function(value) {
                    value = attrs.storeLink;
                    attrs.$set('src', value);
                });
        }
    }]);

    app.directive('storeLink', ['config',
        function(config) {
            //Usage:
            //<a data-store-link="{{mp_link}}"/>
            var directive = {
                link: link,
                restrict: 'A'
            };
            return directive;
            function link(scope, element, attrs) {
                priority: 99,
                    attrs.$observe('storeLink', function(value) {
                        attrs.$set('href', value);
                    });
            }
        }
    ]);

    app.directive('imgProd', ['config',
        function(config) {
            //Usage:
            //<img data-img-product="{{i.file_name}}"/>
            var basePath = config.imageSettings.imgProdURLBase;
            var unknownImage = config.imageSettings.imageProductUnknown;
            var directive = {
                link: link,
                restrict: 'A'
            };
            return directive;
            function link(scope, element, attrs) {
                priority: 99,
                    attrs.$observe('imgProd', function(value) {
                      //console.log(value);
                      if( value.indexOf('-can') === -1 ){
                        value = basePath + (value + '/' + value || unknownImage) + '-' + attrs.imgSize + '.jpg';
                        attrs.$set('src', value);
                      }else{
                        value = basePath + (value.replace('-can','') + '/' + value.replace('-can','') || unknownImage) + '-' + attrs.imgSize + '-can.jpg';
                        attrs.$set('src', value);
                      }

                    });
            }
        }
    ]);

    app.directive('convertToNumber', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {
                ngModel.$parsers.push(function(val) {
                    return parseInt(val, 10);
                });
                ngModel.$formatters.push(function(val) {
                    return '' + val;
                });
            }
        };
    });

    app.directive('dashboardCounter', function() {
        return {
            restrict: 'E',
            compile: function(element, attrs)
            {
                var type = attrs.type || 'text';
                var required = attrs.hasOwnProperty('required') ? "required='required'" : "";
                var htmlText = '<div class="control-group">' +
                    '<label class="control-label" for="' + attrs.formId + '">' + attrs.label + '</label>' +
                    '<div class="controls">' +
                    '<input type="' + type + '" class="input-xlarge" id="' + attrs.formId + '" name="' + attrs.formId + '" ' + required + '>' +
                    '</div>' +
                    '</div>';
                element.replaceWith(htmlText);
            }
        }
    });

    app.directive('keyEnter', function () {
        return function (scope, element, attrs) {
            element.bind('keydown keypress', function (event) {
                if(event.which === 13) {
                    scope.$apply(function (){
                        scope.$eval(attrs.ngEnter, {$event:event});
                    });

                    event.preventDefault();
                }
            });
        };
    });

    app.directive('ccFocus', function($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                if(scope.$eval(attrs['ccFocus'])) {
                    $timeout(function () {
                        element.focus();
                    }, 0);
                }
            }
        };
    });

    app.directive('inputDatetime', function() {
        return {
            require: 'ngModel',
            link: function(scope, element, attrs, ngModel) {

                ngModel.$parsers.push(function(value) {
                    return new Date(value).getTime();
                });

                ngModel.$formatters.push(function(value) {
                    return moment(value).utc().local().format('MMM Do YYYY, h:mm a');
                });
            }
        };
    });


    app.directive('formatDate', function() {
        return {
            require: 'ngModel',
            link: function(scope, elem, attr, modelCtrl) {
                modelCtrl.$formatters.push(function(modelValue){
                    return new Date(modelValue);
                })
            }
        };
    });

    app.directive('ngMin', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elem, attr, ctrl) {
                scope.$watch(attr.ngMin, function () {
                    ctrl.$setViewValue(ctrl.$viewValue);
                });
                var minValidator = function (value) {
                    // todo doesn't check if var not defined
                    var min = attr.ngMin;
                    if (!isEmpty(value) && value < min) {
                        ctrl.$setValidity('ngMin', false);
                        return undefined;
                    } else {
                        ctrl.$setValidity('ngMin', true);
                        return value;
                    }
                };

                ctrl.$parsers.push(minValidator);
                ctrl.$formatters.push(minValidator);
            }
        };
    });

    app.directive('ngMax', function () {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elem, attr, ctrl) {
                scope.$watch(attr.ngMax, function () {
                    ctrl.$setViewValue(ctrl.$viewValue);
                });
                var maxValidator = function (value) {
                    // todo doesn't check if var not defined
                    var max = attr.ngMax;
                    if (!isEmpty(value) && value > max) {
                        ctrl.$setValidity('ngMax', false);
                        return undefined;
                    } else {
                        ctrl.$setValidity('ngMax', true);
                        return value;
                    }
                };

                ctrl.$parsers.push(maxValidator);
                ctrl.$formatters.push(maxValidator);
            }
        };
    });

/*    app.directive('ccUniqueupc', function (datacontext) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {

                ctrl.$parsers.unshift(checkUniqueUPC);

                function checkUniqueUPC(viewValue){
                    datacontext.dup_upc_check({
                        upc: viewValue,
                        product_id: attrs.ccUniqueupc
                    }).then(function (httpResult) {

                        if (httpResult.data.success) {
                            ctrl.$setValidity('upcUnique', true);
                        } else {
                            ctrl.$setValidity('upcUnique', false);
                            scope.checkUniqueUpcPID = httpResult.data.data;
                        }
                        return viewValue;
                    });
                }
            }
        };
    });*/

    app.directive('ccUniqueupc', function ($q, datacontext) {

        return {
            require: 'ngModel',
            link: function (scope, element, attrs, ctrl) {

                //console.log('checkUniqueUPC');

                ctrl.$asyncValidators.upc = function (modelValue, viewValue) {
                    return $q(function (resolve, reject) {
                        datacontext.checkUniqueUPC({
                            upc: viewValue,
                            product_id: attrs.ccUniqueupc
                        }).then(function () {
                            resolve();
                           // console.log('resolve', resolve());
                        }, function () {
                            reject();
                           // console.log('regect', reject());
                        });
                    });
                };
            }
        };
    });

    app.directive('ccChecksumupc', function() {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, elem, attrs, ctrl) {

                // todo add validation check len 8,12,13,14

                ctrl.$parsers.unshift(validateUPC);

                // todo move to util.js for reusablity?
                function padLeft(nr, n, str){
                    return new Array(n-String(nr).length+1).join(str||'0')+nr;
                }

                function validateUPC(upc){

                    var valid = false;
                    var reg = new RegExp('^[0-9]');

                    if (reg.test(upc)) {

                        // Pad with zero's to lengthen to 14 digits
                        var viewValue = padLeft(upc,14);
                        var odd = 0;
                        var even = 0;
                        var checkdigit = Number(viewValue.substr(13, 14));
                        var check = 0;

                        // run checksum
                        for (var i = 1; i < 14; i++) {
                            if (i % 2) {
                                odd = odd + Number(viewValue.slice(i - 1, i));
                            } else {
                                even = even + Number(viewValue.slice(i - 1, i));
                            }
                        }
                        var total = ((odd * 3) + even) % 10;

                        if (total !== 0) {
                            check = (10 - total);
                        }

                        if (check === checkdigit) {
                            valid = true;
                        }
                    }
                    if (valid) {
                        ctrl.$setValidity('checksumUPC', true);
                    } else {
                        ctrl.$setValidity('checksumUPC', false);
                    }
                    return upc;

                }
            }
        };
    });


    app.directive('sortBy', function() {
        return {
            templateUrl: 'sort-by.html',
            restrict: 'E',
            transclude: true,
            replace: true,
            scope: {
                sortdir: '=',
                sortedby: '=',
                sortvalue: '@',
                onsort: '='
            },
            link: function (scope, element, attrs) {
                scope.sort = function () {
                    if (scope.sortedby === scope.sortvalue)
                        scope.sortdir = scope.sortdir === 'asc' ? 'desc' : 'asc';
                    else {
                        scope.sortedby = scope.sortvalue;
                        scope.sortdir = 'asc';
                    }
                    scope.onsort(scope.sortedby, scope.sortdir);
                };
            }
        };
    });

    app.directive('onBlurChange', function() {
        return function (scope, element, attr) {
            var fn = $parse(attr['onBlurChange']);
            var hasChanged = false;
            element.on('change', function (event) {
                hasChanged = true;
            });

            element.on('blur', function (event) {
                if (hasChanged) {
                    scope.$apply(function () {
                        fn(scope, {$event: event});
                    });
                    hasChanged = false;
                }
            });
        };
    });

    app.directive('onEnterBlur', function() {
        return function(scope, element, attrs) {
            element.bind("keydown keypress", function(event) {
                if(event.which === 13) {
                    element.blur();
                    event.preventDefault();
                }
            });
        };
    });

    app.directive('printDiv', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {

                element.bind('click', function(event) {
                    event.preventDefault();
                    new PrintWithIframe($(attrs.printDiv).html());
                });

                function PrintWithIframe(data)
                {
                    $('html').append('<iframe id="printf" name="printf" width="400" height="600"></iframe>');
                    // an iFrame is added to the html content,
                    // then your div's contents are added to it and the iFrame's content is printed

                    var mywindow = window.frames["printf"];
                    mywindow.document.write('<html><head><title></title><style>@page {margin: 0mm;}</style>' +
                    '</head><body onload="window.print()"><div style="width:400px;height:600px;">' + data + '</div></body></html>');

                    $(mywindow.document).ready(function(){
                        setTimeout(function() {mywindow.print();},1500);
                        setTimeout(function(){
                        $('iframe#printf').remove();
                            },
                            4000);
                            // The iFrame is removed 2 seconds after print() is executed,
                            // which is enough for me, but you can play around with the value
                    });
                }
            }
        };
    });

    app.directive('chosen', function() {
        var linker = function(scope, element, attr) {
            // update the select when data is loaded
            scope.$watch(attr.chosen, function(oldVal, newVal) {
                element.trigger('chosen:updated');
            });

            // update the select when the model changes
            scope.$watch(attr.ngModel, function() {
                element.trigger('chosen:updated');
            });

            element.chosen();
        };

        return {
            restrict: 'A',
            link: linker
        };
    });

    app.directive('printShip', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                element.bind('click', function(evt) {
                    evt.preventDefault();
                    PrintElem(attrs.printDiv);
                });

                function PrintElem(data)   {
                    var left = Number((screen.width/2)-(700/2));
                    var top = Number((screen.height/2)-(500/2));

                    var myWindow=window.open('','','channelmode=0,directories=0,fullscreen=0,location=0,menubar=0,resizable=0,scrollbars=0,status=0,width=400,height=600,top=' + top + ',left=' + left);
                    myWindow.document.write('<p>' + data + '</p>');
                    myWindow.document.close();
                    myWindow.focus();
                    myWindow.print();
                    myWindow.close();
                }
                return true;
            }
        };
    });

    app.directive('toggleSwitch', function() {
        return {
            restrict: 'EA',
            replace: true,
            scope: {
                model: '=',
                disabled: '@',
                onLabel: '@',
                offLabel: '@',
                knobLabel: '@'
            },
            template: '<div class="switch" ng-class="{ \'disabled\': disabled }"><div class="switch-animate" ng-class="{\'switch-off\': !model, \'switch-on\': model}"><span class="switch-left" ng-bind="onLabel"></span><span class="knob" ng-bind="knobLabel"></span><span class="switch-right" ng-bind="offLabel"></span></div></div>',
            link: function(scope, element, attrs){
                if (!attrs.onLabel) { attrs.onLabel = 'YES'; }
                if (!attrs.offLabel) { attrs.offLabel = 'NO'; }
                if (!attrs.knobLabel) { attrs.knobLabel = '\u00a0'; }
                if (!attrs.disabled) { attrs.disabled = false; }

                element.on('click', function() {
                    scope.$apply(scope.toggle);
                });

                scope.toggle = function toggle() {
                    if(!scope.disabled) {
                        scope.model = !scope.model;
                    }
                };
            }
        };
    });

    app.directive('optionsClass', function ($parse) {
        return {
            require: 'select',
            link: function(scope, elem, attrs, ngSelect) {
                // get the source for the items array that populates the select.
                var optionsSourceStr = attrs.ngOptions.split(' ').pop(),
                // use $parse to get a function from the options-class attribute
                // that you can use to evaluate later.
                    getOptionsClass = $parse(attrs.optionsClass);

                scope.$watch(optionsSourceStr, function(items) {
                    // when the options source changes loop through its items.
                    angular.forEach(items, function(item, index) {
                        // evaluate against the item to get a mapping object for
                        // for your classes.
                        var classes = getOptionsClass(item),
                        // also get the option you're going to need. This can be found
                        // by looking for the option with the appropriate index in the
                        // value attribute.
                            option = elem.find('option[value=' + index + ']');

                        // now loop through the key/value pairs in the mapping object
                        // and apply the classes that evaluated to be truthy.
                        angular.forEach(classes, function(add, className) {
                            if(add) {
                                angular.element(option).addClass(className);
                            }
                        });
                    });
                });
            }
        };
    });


    app.directive('ccSpinner', ['$window', function ($window) {
        // Description:
        //  Creates a new Spinner and sets its options
        // Usage:
        //  <div data-cc-spinner="vm.spinnerOptions"></div>
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element, attrs) {
            scope.spinner = null;
            scope.$watch(attrs.ccSpinner, function (options) {
                if (scope.spinner) {
                    scope.spinner.stop();
                }
                scope.spinner = new $window.Spinner(options);
                scope.spinner.spin(element[0]);
            }, true);
        }
    }]);

    app.directive('prToggle', function() {
        return {
            restrict: 'E',
            transclude: true,
            scope: false,
            templateUrl: '/app/products/partials/relationship_label_toggle.html',
            link: function(scope, element, attrs){

                scope.toggle = function (data) {


                    var payload = {
                        "product_id" : data.pid,
                        "linked_product_id" : data.lpid,
                        "type_id" : data.tid
                    };

                    if ( ! scope.hasMatch ) {
                        scope.create_product_relationship(payload);
                        scope.hasMatch = 1;
                    } else {
                        // delete
                        scope.deleteProductRelationship(payload);
                        scope.hasMatch = 0;
                    }
                };

                // set match default to false
                scope.hasMatch = 0;

                // convert back to js object
                var objActive = angular.fromJson(attrs.activelist);
                for (var i in objActive) {

                    if (Number(objActive[i].linked_product_id) === Number(attrs.lpid) &&
                        Number(objActive[i].type_id) === Number(attrs.tid) ) {
                        scope.hasMatch = 1;
                    }
                }

                scope.data = {
                    "lpid":attrs.lpid,
                    "tid":attrs.tid,
                    "pid":attrs.pid,
                    "match":scope.hasMatch
                };

            }
        };
    });

    //
    /**
     * Checklist-model
     * AngularJS directive for list of checkboxes
     * https://github.com/vitalets/checklist-model
     * License: MIT http://opensource.org/licenses/MIT
     */

    app.directive('checklistModel', ['$parse', '$compile', function($parse, $compile) {
            // contains
            function contains(arr, item, comparator) {
                if (angular.isArray(arr)) {
                    for (var i = arr.length; i--;) {
                        if (comparator(arr[i], item)) {
                            return true;
                        }
                    }
                }
                return false;
            }

            // add
            function add(arr, item, comparator) {
                arr = angular.isArray(arr) ? arr : [];
                if(!contains(arr, item, comparator)) {
                    arr.push(item);
                }
                return arr;
            }

            // remove
            function remove(arr, item, comparator) {
                if (angular.isArray(arr)) {
                    for (var i = arr.length; i--;) {
                        if (comparator(arr[i], item)) {
                            arr.splice(i, 1);
                            break;
                        }
                    }
                }
                return arr;
            }

            // http://stackoverflow.com/a/19228302/1458162
            function postLinkFn(scope, elem, attrs) {
                // exclude recursion, but still keep the model
                var checklistModel = attrs.checklistModel;
                attrs.$set("checklistModel", null);
                // compile with `ng-model` pointing to `checked`
                $compile(elem)(scope);
                attrs.$set("checklistModel", checklistModel);

                // getter for original model
                var checklistModelGetter = $parse(checklistModel);
                var checklistChange = $parse(attrs.checklistChange);
                var checklistBeforeChange = $parse(attrs.checklistBeforeChange);
                var ngModelGetter = $parse(attrs.ngModel);

                var comparator = angular.equals;

                if (attrs.hasOwnProperty('checklistComparator')){
                    if (attrs.checklistComparator[0] == '.') {
                        var comparatorExpression = attrs.checklistComparator.substring(1);
                        comparator = function (a, b) {
                            return a[comparatorExpression] === b[comparatorExpression];
                        };

                    } else {
                        comparator = $parse(attrs.checklistComparator)(scope.$parent);
                    }
                }

                // watch UI checked change
                scope.$watch(attrs.ngModel, function(newValue, oldValue) {
                    if (newValue === oldValue) {
                        return;
                    }

                    if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
                        ngModelGetter.assign(scope, contains(checklistModelGetter(scope.$parent), getChecklistValue(), comparator));
                        return;
                    }

                    setValueInChecklistModel(getChecklistValue(), newValue);

                    if (checklistChange) {
                        checklistChange(scope);
                    }
                });

                // watches for value change of checklistValue (Credit to @blingerson)
                scope.$watch(getChecklistValue, function(newValue, oldValue) {
                    if( newValue != oldValue && angular.isDefined(oldValue) && scope[attrs.ngModel] === true ) {
                        var current = checklistModelGetter(scope.$parent);
                        checklistModelGetter.assign(scope.$parent, remove(current, oldValue, comparator));
                        checklistModelGetter.assign(scope.$parent, add(current, newValue, comparator));
                    }
                });

                function getChecklistValue() {
                    return attrs.checklistValue ? $parse(attrs.checklistValue)(scope.$parent) : attrs.value;
                }

                function setValueInChecklistModel(value, checked) {
                    var current = checklistModelGetter(scope.$parent);
                    if (angular.isFunction(checklistModelGetter.assign)) {
                        if (checked === true) {
                            checklistModelGetter.assign(scope.$parent, add(current, value, comparator));
                        } else {
                            checklistModelGetter.assign(scope.$parent, remove(current, value, comparator));
                        }
                    }

                }

                // declare one function to be used for both $watch functions
                function setChecked(newArr, oldArr) {
                    if (checklistBeforeChange && (checklistBeforeChange(scope) === false)) {
                        setValueInChecklistModel(getChecklistValue(), ngModelGetter(scope));
                        return;
                    }
                    ngModelGetter.assign(scope, contains(newArr, getChecklistValue(), comparator));
                }

                // watch original model change
                // use the faster $watchCollection method if it's available
                if (angular.isFunction(scope.$parent.$watchCollection)) {
                    scope.$parent.$watchCollection(checklistModel, setChecked);
                } else {
                    scope.$parent.$watch(checklistModel, setChecked, true);
                }
            }

            return {
                restrict: 'A',
                priority: 1000,
                terminal: true,
                scope: true,
                compile: function(tElement, tAttrs) {

                    if (!tAttrs.checklistValue && !tAttrs.value) {
                        throw 'You should provide `value` or `checklist-value`.';
                    }

                    // by default ngModel is 'checked', so we set it if not specified
                    if (!tAttrs.ngModel) {
                        // local scope var storing individual checkbox model
                        tAttrs.$set("ngModel", "checked");
                    }

                    return postLinkFn;
                }
            };
        }]);

            //

    app.directive('printProductImage', function() {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                element.bind('click', function(evt) {
                    evt.preventDefault();
                    new PrintElem(attrs.printDiv);
                });

                function PrintElem(elem) {
                    new PrintWithIframe($(elem).html());
                }

                function PrintWithIframe()
                {
                    if ($('iframe#printf').size() === 0) {
                        $('html').append('<iframe id="printf" name="printf" width="400" height="600"></iframe>');  // an iFrame is added to the html content, then your div's contents are added to it and the iFrame's content is printed

                        var mywindow = window.frames['printf'];
                        mywindow.document.write('<html><head><title></title><style>@page {margin: 0mm;}</style>'+
                        '</head><body><img height="600" width="400" data-ng-src="http://s3.amazonaws.com/gco_bucket/products/' +
                        product_id + '.jpg"/></body></html>');

                        $(mywindow.document).ready(function(){
                            mywindow.print();
                            setTimeout(function(){
                                    $('iframe#printf').remove();
                                },
                                1000);  // The iFrame is removed 2 seconds after print() is executed, which is enough for me, but you can play around with the value
                        });
                    }
                }
            }
        };
    });

})();
